import '../styles.scss'

import clsx from 'clsx'
import { initEmojiMart } from 'config/emojiSetup.ts'
import { ui as ContactsUI } from 'features/contacts'
import { ExecutionsUI } from 'features/executions'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useFiltersQuerySync } from '../../hooks/useFiltersQuerySync'
import { ConfirmDialog } from '../ConfirmDialog'
import { Conversations } from '../Conversations/Conversations'
import { SearchForm } from '../FilterForm/SearchForm.tsx'
import { Participant } from '../Participant/Participant'
import { QuickActions } from '../QuickActions'
import css from './Mailbox.module.css'


export function Mailbox() {
  useFiltersQuerySync()
  useEffect(() => {
    initEmojiMart()
  }, [])

	return (
		<div className={clsx(css.wrapper, 'main app-scroll')}>
			<div className={css.side}>
				<SearchForm />
				<Conversations />
			</div>
			<QuickActions />
			<main className={css.main}>
				<Outlet />
			</main>

			<div className={clsx(css.card, 'app-scroll-thin')}>
				<Participant />
				<ExecutionsUI.UpcomingEvents />
				<ContactsUI.Note />
			</div>

			<ConfirmDialog />
		</div>
	)
}
